import { FeatureToggleClientService } from 'feature-toggle-client';
export const BlipCopilotMFE = 'blip-copilot-mfe';
export class BlipCopilotFeatures {
    static async isBlipCopilotMFEEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(BlipCopilotMFE, false);
    }
}
